import Chip from 'material-ui/Chip';
import {getDisplayableShortGrade} from '../services';
import muiTheme from '../../../styles/teamologyTheme';
import React, {PropTypes} from 'react';

const getActiveFilterText = (filterOptions, mapping) => filterOptions.filter(o => o.value).map(mapping);

const getAllActiveFilters = filters => {
  const otherMapping = o => Object({id: o.id, text: o.text, parent: 'other'});
  const gradeMapping = o => Object({id: o.id, text: getDisplayableShortGrade(o), parent: 'grades'});
  const characterMapping = o => Object({id: o.id, text: `${o.name} - ${o.foundation}`, parent: 'characters'});
  const subjectMapping = o => Object({id: o.id, text: `${o.name}`, parent: 'subjects'});

  const characterOptions = getActiveFilterText(filters.characters, characterMapping);
  const gradeOptions = getActiveFilterText(filters.grades, gradeMapping);
  const otherOptions = getActiveFilterText(filters.other, otherMapping);
  const subjectOptions = getActiveFilterText(filters.subjects || [], subjectMapping);

  return characterOptions
    .concat(gradeOptions)
    .concat(otherOptions)
    .concat(subjectOptions);
};

const bindFilterRemoveHandler = (handler, parent, id) => handler.bind(null, parent, id);

export default function FilterChips({filters, onFilterRemove}) {
  const activeFilters = getAllActiveFilters(filters);

  const containerStyle = {
    display: 'flex',
    flexWrap: 'wrap',
  };

  return (
    <div className="filter-chips">
      <div style={containerStyle}>
        {activeFilters.map(o =>
          <Chip key={o.id}
                style={muiTheme.chip}
                labelStyle={muiTheme.chipLabel}
                onRequestDelete={bindFilterRemoveHandler(onFilterRemove, o.parent, o.id)}>
            {o.text}
          </Chip>
        )}
      </div>
    </div>
  );
}

FilterChips.propTypes = {
  filters: PropTypes.object.isRequired,
  onFilterRemove: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./app/features/shared/components/FilterChips.js